module.exports = __webpack_public_path__ + "img/5.504536bb.png";